import { mapState } from 'vuex'
import drawer from '../mixins/drawer'

export default {
  mixins: [drawer],
  computed: {
    ...mapState({
      pages: state => state.pages
    })
  },
  methods: {
    prepareData () {
      return Promise.resolve().then(() => {
        return this.$bus.$emit('message:refresh')
      }).then(() => {
        return this.toggleDrawer({
          target: 'appMenu',
          value: true
        })
      }).then(() => {
        return this.getMenus()
      }).then(() => {
        return this.getPages()
      }).catch(() => {})
    },
    getMenus () {
      return this.$http.post('/base/auth/user/menus').then(response => {
        this.$store.commit('assignValue', {
          menus: _.get(response.data, 'data')
        })
      })
    },
    getPages () {
      return this.$http.post('/base/auth/user/pages').then(response => {
        this.$store.commit('assignValue', {
          pages: _.get(response.data, 'data')
        })
      })
    },
    addRoutes () {
      return Promise.resolve().then(() => {
        const paths = _.map(this.$router.options.routes, 'path')
        const pages = _.filter(this.pages, page => paths.indexOf(page.path) === -1 && !!page.component)
        const routes = _.map(pages, page => ({
          path: page.path,
          component: () => import(/* webpackChunkName: "pages" */ `@pages/${page.component}`),
          meta: {
            title: page.title
          }
        }))
        this.$router.addRoutes(routes)
      })
    }
  }
}
